import React from 'react';
import { Affix, Alert, Card, Table } from 'antd';
import {
    AUTO_OFF_PATH1,
    AUTO_OFF_PATH2,
    AUTO_ON_CONDITIONS,
    IMAGE_RULES,
    MANUAL_RULES,
    PROMO_IMAGE_RULES,
    STICKY_ALERT_OFFSET_TOP,
} from './constants';

const condColumns = [
    { title: '条件', dataIndex: 'cond', key: 'cond', width: 160 },
    { title: '要求', dataIndex: 'req', key: 'req' },
];

const imageColumns = [
    { title: '当前图片体系', dataIndex: 'system', key: 'system', width: 140 },
    { title: '有图', dataIndex: 'hasImage', key: 'hasImage' },
    { title: '无图', dataIndex: 'noImage', key: 'noImage' },
];

const promoColumns = [
    { title: '品类组', dataIndex: 'group', key: 'group', width: 140 },
    { title: '适用品类', dataIndex: 'categories', key: 'categories' },
    { title: '有图条件', dataIndex: 'rule', key: 'rule' },
];

const kvColumns = [
    { title: '项目', dataIndex: 'item', key: 'item', width: 160 },
    { title: '说明', dataIndex: 'desc', key: 'desc' },
];

export const IntroTab = () => {
    return (
        <div className="shelf-rule__intro">
            <Affix offsetTop={STICKY_ALERT_OFFSET_TOP}>
                <div className="shelf-rule__sticky-alert">
                    <Alert
                        type="info"
                        showIcon
                        message="自动上下架条件固定，只有禁止上架/禁止下架名单可改"
                        description="自动上架、下架条件按业务表只读展示，运营不能改阈值。禁止上架名单、禁止下架名单请到对应分区维护。本页内容随顶栏工作品牌切换。"
                    />
                </div>
            </Affix>
            <Card type="inner" title="怎么判定" style={{ marginBottom: 16 }}>
                <ul className="shelf-rule__judge">
                    <li>自动上架：满足全部条件，且不在禁止上架名单 → 上架</li>
                    <li>自动下架：命中下架条件，且不在禁止下架名单 → 下架，或进入倒计时</li>
                    <li>人工上架：先过硬门禁；若在禁止上架名单 → 确认后移出名单再上架</li>
                    <li>人工下架：下架，并写入禁止上架名单（禁止自动再上架）</li>
                </ul>
                <Table
                    bordered
                    size="small"
                    showHeader={false}
                    pagination={false}
                    rowKey="key"
                    columns={[
                        { title: '名单', dataIndex: 'name', key: 'name', width: 160 },
                        { title: '说明', dataIndex: 'desc', key: 'desc' },
                    ]}
                    dataSource={[
                        {
                            key: '1',
                            name: '禁止上架名单',
                            desc:
                                '用来禁止自动上架。承接原黑名单、人工下架写入、活动定时任务写入，也可由运营直接加入。所属 SPU 或该 SKU 任一在名单即命中。',
                        },
                        {
                            key: '2',
                            name: '禁止下架名单',
                            desc:
                                '用来禁止自动下架（含立即下架与 24 小时倒计时）。无货仍展示，前台可搜索。所属 SPU 或该 SKU 任一在名单即命中。',
                        },
                    ]}
                />
            </Card>
            <Card
                type="inner"
                title="自动上架条件（须全部满足，满足后立即上架）"
                style={{ marginBottom: 16 }}
            >
                <Table
                    bordered
                    size="small"
                    pagination={false}
                    rowKey="key"
                    columns={condColumns}
                    dataSource={AUTO_ON_CONDITIONS}
                />
            </Card>
            <Card type="inner" title="怎样算有图" style={{ marginBottom: 16 }}>
                <Table
                    bordered
                    size="small"
                    pagination={false}
                    rowKey="key"
                    columns={imageColumns}
                    dataSource={IMAGE_RULES}
                    style={{ marginBottom: 16 }}
                />
                <div className="shelf-rule__subtitle">品真阁：无电商图时看推广图</div>
                <Table
                    bordered
                    size="small"
                    pagination={false}
                    rowKey="key"
                    columns={promoColumns}
                    dataSource={PROMO_IMAGE_RULES}
                    style={{ marginBottom: 12 }}
                />
                <ul className="shelf-rule__notes">
                    <li>
                        电商图数量 &gt; 0 即有图；电商图为 0 时，按珠宝与贵金属 /
                        二手奢品类看推广图（二手奢等级为空按 N 级）。中台图不参与有图判定。
                    </li>
                    <li>自动上架、自动下架与人工上架共用上述口径。</li>
                    <li>人工上架无图时提示「该商品缺少可用图片，无法上架」。</li>
                    <li>
                        所属 SPU 或该 SKU
                        任一在禁止上架名单，即禁止自动上架。人工下架会写入禁止上架名单；卖出或规则自动下架不会写入。
                    </li>
                </ul>
            </Card>
            <Card type="inner" title="自动下架条件" style={{ marginBottom: 16 }}>
                <div className="shelf-rule__subtitle">路径一：24 小时倒计时下架</div>
                <Table
                    bordered
                    size="small"
                    showHeader={false}
                    pagination={false}
                    rowKey="key"
                    columns={kvColumns}
                    dataSource={AUTO_OFF_PATH1}
                    style={{ marginBottom: 16 }}
                />
                <div className="shelf-rule__subtitle">路径二：立即下架</div>
                <Table
                    bordered
                    size="small"
                    showHeader={false}
                    pagination={false}
                    rowKey="key"
                    columns={kvColumns}
                    dataSource={AUTO_OFF_PATH2}
                    style={{ marginBottom: 12 }}
                />
                <ul className="shelf-rule__notes">
                    <li>已上架 SKU 在当前图片体系下变为无图时，立即下架。</li>
                    <li>
                        所属 SPU 或该 SKU 任一在禁止下架名单时，不会自动下架；已上架且可售库存为 0
                        时仍保持上架，前台可搜索展示（爆款无货曝光）。
                    </li>
                    <li>卖出或规则自动下架，不会写入禁止上架名单。</li>
                </ul>
            </Card>
            <Card type="inner" title="人工上下架" style={{ marginBottom: 16 }}>
                <Table
                    bordered
                    size="small"
                    showHeader={false}
                    pagination={false}
                    rowKey="key"
                    columns={kvColumns}
                    dataSource={MANUAL_RULES}
                />
            </Card>
            <Card type="inner" title="执行流程">
                <div className="shelf-rule__flow-wrap">
                    <div className="shelf-rule__flow">
                        <span className="shelf-rule__flow-step">数据变更</span>
                        <span className="shelf-rule__arrow">→</span>
                        <span className="shelf-rule__flow-step">按 SKU 评估规则</span>
                        <span className="shelf-rule__arrow">→</span>
                        <span className="shelf-rule__flow-step shelf-rule__flow-step--active">
                            判断名单
                        </span>
                    </div>
                    <div className="shelf-rule__flow-cards">
                        <div className="shelf-rule__flow-card">
                            <div className="shelf-rule__flow-card-title">上架</div>
                            <div className="shelf-rule__flow-card-desc">
                                当前下架，条件全部满足，且不在禁止上架名单 → 立即上架
                            </div>
                        </div>
                        <div className="shelf-rule__flow-card">
                            <div className="shelf-rule__flow-card-title">下架</div>
                            <div className="shelf-rule__flow-card-desc">
                                无图立即下架；有图进入 24 小时倒计时；到期或加速时执行下架
                            </div>
                        </div>
                    </div>
                    <div className="shelf-rule__flow">
                        <span className="shelf-rule__flow-step">执行上下架</span>
                        <span className="shelf-rule__arrow">→</span>
                        <span className="shelf-rule__flow-step">写入执行日志</span>
                        <span className="shelf-rule__arrow">→</span>
                        <span className="shelf-rule__flow-step">定时扫表补到期下架</span>
                    </div>
                </div>
            </Card>
        </div>
    );
};
